import has from 'lodash/has';
import * as types from '../../constants/actionTypes';
import { normalize } from 'normalizr';
import { addEntities } from '../../actions/entities';
import { authFetch } from '../../api';

const request = () => ({
	type: types.ADMIN_NOTIFICATION_UPDATE_REQUEST,
});

const success = (notification, message = '') => ({
	type: types.ADMIN_NOTIFICATION_UPDATE_SUCCESS,
	payload: {
		notification,
		message,
	},
});

const failure = (message = 'Something went wrong.') => ({
	type: types.ADMIN_NOTIFICATION_UPDATE_FAILURE,
	payload: {
		message,
	},
});

export default function update(notificationId) {
	return (dispatch, getState, { schema }) => {
		dispatch(request());

		const state = getState();

		const {
			message,
			type,
			from,
			to,
		} = state.form.adminNotificationEditForm.values;

		const notification = {
			message,
			type,
			from: from.replace('T', ' '),
			to: to.replace('T', ' '),
		};

		const { token } = state.auth;

		return authFetch(
			`admin-notifications/${notificationId}`,
			{
				method: 'put',
				credentials: 'same-origin',
				body: JSON.stringify(notification),
			},
			token,
			dispatch,
		)
			.then(res => res.json())
			.then(res => {
				if (!has(res, 'admin_notification')) {
					return has(res, 'error')
						? dispatch(failure(res.error))
						: dispatch(failure('Something went wrong.'));
				}

				const data = normalize(
					[res.admin_notification],
					[schema.adminNotification],
				);
				dispatch(addEntities(data.entities));
				return dispatch(success(data.result[0], res.message));
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/updateAdminNotification.js